import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "javascript-and-xd-plugin-apis"
    }}>{`JavaScript and XD Plugin APIs`}</h1>
    <p>{`XD plugins are written in JavaScript, the language of the web which is also frequently used for servers, OS scripting, and more.`}</p>
    <p>{`If JavaScript is new to you, we recommend trying an introductory JavaScript tutorial elsewhere. You certainly don't need to know everything about JavaScript to build useful XD plugins; once you have a grasp on the basics of the language, you can learn as you create!`}</p>
    <p>{`If you're familiar with JavaScript, you'll find that many of your skills apply to creating XD plugins. There are some special rules of the road you'll want to know, and that's what this advanced concepts section is all about.`}</p>
    <p>{`In this section, we'll talk about JavaScript topics that are specific to XD plugin APIs.`}</p>
    <p>{`Topics include:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "javascript-support/"
        }}>{`JavaScript version and feature support`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "sync-async/"
        }}>{`Sync and Async`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "environment/"
        }}>{`The API environment`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      